/**
 * Tema — os quatro do protótipo: automático, branco, preto e navy.
 *
 * `auto` NÃO grava `data-tema` no documento: o CSS cai no bloco de
 * `prefers-color-scheme`, e a página vira junto com o Windows sem recarregar.
 * Gravar um valor fixo quebraria exatamente isso.
 */

export const TEMAS = [
  { id: "auto", nome: "Automático", desc: "Acompanha o sistema" },
  { id: "branco", nome: "Branco", desc: "Destaque azul escuro" },
  { id: "navy", nome: "Azul navy", desc: "Destaque laranja" },
  { id: "preto", nome: "Preto", desc: "Escuro neutro" },
] as const;

export type IdTema = (typeof TEMAS)[number]["id"];

const CHAVE = "autodis.tema";

export function lerTema(): IdTema {
  const v = localStorage.getItem(CHAVE);
  return TEMAS.some((t) => t.id === v) ? (v as IdTema) : "auto";
}

export function aplicarTema(id: IdTema): void {
  const raiz = document.documentElement;
  if (id === "auto") raiz.removeAttribute("data-tema");
  else raiz.setAttribute("data-tema", id);
  try {
    localStorage.setItem(CHAVE, id);
  } catch {
    /* modo privado: o tema vale só nesta sessão */
  }
}

export function iniciarTema(): void {
  aplicarTema(lerTema());
}
